<template>
  <form @submit.prevent="save">
    <div class="modal-header">
      <h4 class="modal-title">{{ formTitle }}</h4>
    </div>
    <div class="modal-body">
      <div class="form-group" :class="{ 'has-error': errors.name }">
        <label for="subgroup-name">Name</label>
        <input type="text" id="subgroup-name" class="form-control" v-model="form.name">
        <p v-if="errors.name" class="help-block">{{ errors.name }}</p>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.type }">
        <label for="subgroup-type">Type</label>
        <select id="subgroup-type" class="form-control" v-model="typeSelection" @change="handleTypeChange">
          <option value="">-- Select Type --</option>
          <option v-for="type in defaultTypes" :key="type.value" :value="type.value">{{ type.label }}</option>
          <option value="custom">Custom...</option>
        </select>
        <input
          v-if="typeSelection === 'custom'"
          type="text"
          id="subgroup-type-custom"
          class="form-control custom-type"
          v-model="form.type"
          placeholder="Enter custom type"
          maxlength="64"
          aria-label="Enter custom type"
        >
        <p v-if="errors.type" class="help-block">{{ errors.type }}</p>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" @click="cancel">Cancel</button>
      <button type="submit" class="btn btn-primary" :disabled="saving">{{ saving ? 'Saving...' : 'Save' }}</button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'SubgroupForm',
  props: {
    subgroup: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        uuid: '',
        name: '',
        type: '',
      },
      typeSelection: '',
      errors: {},
      saving: false,
    };
  },
  computed: {
    formTitle() {
      return this.subgroup ? 'Edit Subgroup' : 'Add Subgroup';
    },
    defaultTypes() {
      return [
        { value: 'region', label: 'Region'},
        { value: 'feeder', label: 'Feeder'},
        { value: 'area', label: 'Area' },
        { value: 'cohort', label: 'Cohort' },
        { value: 'pilot', label: 'Pilot' },
        { value: 'learning network', label: 'Learning Network' },
        { value: 'LEA', label: 'LEA' },
        { value: 'district', label: 'District' },
        { value: 'coordinator', label: 'Coordinator' },
        { value: 'SLD Collaborative', label: 'SLD Collaborative' },
        { value: 'grade band', label: 'Grade Band' }
      ];
    },
  },
  watch: {
    subgroup: {
      handler(newVal) {
        if (newVal) {
          this.form.name = newVal.name;
          this.form.uuid = newVal.uuid;
          this.form.type = newVal.type || '';
          this.setTypeSelection(newVal.type);
        } else {
          this.form.name = '';
          this.form.uuid = '';
          this.form.type = '';
          this.typeSelection = '';
        }
        this.errors = {};
      },
      immediate: true,
    },
  },
  methods: {
    setTypeSelection(type) {
      if (!type) {
        this.typeSelection = '';
      } else if (this.isDefaultType(type)) {
        this.typeSelection = type;
      } else {
        this.typeSelection = 'custom';
      }
    },
    isDefaultType(type) {
      return this.defaultTypes.some(defaultType => defaultType.value === type);
    },
    handleTypeChange() {
      if (this.isDefaultType(this.typeSelection)) {
        this.form.type = this.typeSelection;
      } else if (this.typeSelection === '') {
        this.form.type = '';
      }
    },
    save() {
      this.errors = {};
      const name = (this.form.name || '').trim();
      if (!name) {
        this.errors.name = 'Name is required.';
        return;
      }
      const type = (this.form.type || '').trim();
      if (type.length > 64) {
        this.errors.type = 'Type cannot exceed 64 characters.';
        return;
      }
      this.form.type = type;
      this.saving = true;
      this.$emit('save', this.form);
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
<style scoped>
.custom-type {
  margin-top: 10px;
}
</style>